import React from 'react';
import { Box, Typography, Skeleton, useTheme } from '@mui/material';

const ContactItem = ({ icon, title, value, href, isLoading, show }) => {
    const theme = useTheme();

    if (!isLoading && !show) return null;

    const content = (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                textDecoration: 'none',
                color: 'inherit',
                transition: 'all 0.3s ease',
                p: 2,
                borderRadius: 2,
                '&:hover': href ? {
                    backgroundColor: 'grey.100',
                    '& .value-text': {
                        color: theme.palette.text.link,
                    }
                } : {}
            }}
        >
            <Box
                className="icon-box"
                sx={{
                    width: 50,
                    height: 50,
                    borderRadius: '12px',
                    background: theme.palette.custom.serviceIconBg,
                    color: theme.palette.custom.serviceIconColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    transition: 'all 0.3s ease',
                }}
            >
                {React.cloneElement(icon, { fontSize: 'medium' })}
            </Box>

            <Box>
                <Typography variant="body2" color="text.secondary" typography="textSm">
                    {isLoading ? <Skeleton variant="text" height={20} width={100} /> : title}
                </Typography>
                <Typography
                    variant="body1"
                    className='value-text'
                    sx={{
                        fontSize: 16,
                        color: "text.primary",
                        fontWeight: "600",
                        wordBreak: 'break-all'
                    }}
                >
                    {isLoading ? <Skeleton variant="text" height={20} width={140} /> : value}
                </Typography>
            </Box>
        </Box>
    );

    if (href && !isLoading) {
        return (
            <a href={href} style={{ textDecoration: 'none' }} target={href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
                {content}
            </a>
        );
    }

    return content;
};

export default ContactItem;
